import React, { useEffect, useState } from 'react';
import { useStateSelector } from '../../store/selectors';
import Rodal from '../Rodal/Rodal';
import { ModalBody, ModalHeader } from 'reactstrap';
import { useDispatch } from 'react-redux';
import './BuyerNdaTermPreferencesPopup.scss';
import { Form } from '@availity/form';
import { NdaTermPreferences } from '../../containers/Admin/BuyerMarketplace/BuyerProfile/PublicProfile/NdaTermPreferences/NdaTermPreferences';
import moment from 'moment';
import { GetBuyerNdaTermPreferences } from '../../slices/marketplace/buyer/thunks/get-nda-term-preferences';
import { GetBuyer } from '../../slices/marketplace/buyer/thunks/get-buyer.thunk';

interface BuyerNdaTermPreferencesPopupProps {
    buyerId: number;
    close(): void;
}

export const BuyerNdaTermPreferencesPopup = (
    props: BuyerNdaTermPreferencesPopupProps
) => {
    const targetBuyer = useStateSelector(
        (state) => state.buyersState.targetBuyer
    );
    const dispatch = useDispatch() as any;
    const [
        ndaTermPreferencesStateOptionId,
        setNdaTermPreferencesStateOptionId,
    ] = useState(0);
    const [ndaTermPreferencesState, setNdaTermPreferencesState] =
        useState(null);
    const [formValues, setFormValues] = useState({});

    useEffect(() => {
        fetchProfile();
    }, []);

    useEffect(() => {
        if (
            targetBuyer?.profile?.ndaTermPreferencesSnapshots?.length &&
            targetBuyer.id === props.buyerId
        ) {
            const sortedPreferences = [
                ...targetBuyer?.profile.ndaTermPreferencesSnapshots,
            ].sort((a, b) => {
                if (a.isSnapshot !== b.isSnapshot) {
                    return a.isSnapshot ? 1 : -1;
                }
                return (
                    moment(b.dateCreated).valueOf() -
                    moment(a.dateCreated).valueOf()
                );
            });

            const latestPreference = sortedPreferences[0];

            if (latestPreference) {
                setNdaTermPreferencesStateOptionId(latestPreference.id);
                setNdaTermPreferencesState(latestPreference);
            }
        }
    }, [targetBuyer?.profile?.ndaTermPreferencesSnapshots]);

    useEffect(() => {
        if (ndaTermPreferencesState) {
            setFormValues({
                nonDisclosurePeriod:
                    ndaTermPreferencesState?.nonDisclosurePeriod ?? 0,
                nonSolicitationDvmNamesVisible:
                    ndaTermPreferencesState?.nonSolicitationDvmNamesVisible ??
                    0,
                nonSolicitationDvmNamesBlinded:
                    ndaTermPreferencesState?.nonSolicitationDvmNamesBlinded ??
                    0,
                nonSolicitationStaffNamesVisible:
                    ndaTermPreferencesState?.nonSolicitationStaffNamesVisible ??
                    0,
                nonSolicitationStaffNamesBlinded:
                    ndaTermPreferencesState?.nonSolicitationStaffNamesBlinded ??
                    0,
            });
        }
    }, [ndaTermPreferencesState, ndaTermPreferencesStateOptionId]);

    const fetchProfile = async () => {
        await dispatch(GetBuyer(props.buyerId));
        await dispatch(GetBuyerNdaTermPreferences(props.buyerId));
    };

    const handleSelectChange = (stateId: number) => {
        setNdaTermPreferencesStateOptionId(stateId);
        let ndaTermPreference =
            targetBuyer?.profile?.ndaTermPreferencesSnapshots?.find(
                (x) => x.id === stateId
            );
        setNdaTermPreferencesState(ndaTermPreference);
    };

    const getSelectOptions = () => {
        if (
            !targetBuyer?.profile?.ndaTermPreferencesSnapshots ||
            targetBuyer?.profile.ndaTermPreferencesSnapshots.length === 0
        )
            return [{ id: 0, name: 'Current' }];

        return [...targetBuyer?.profile.ndaTermPreferencesSnapshots]
            .sort((a, b) => {
                if (a.isSnapshot !== b.isSnapshot) {
                    return a.isSnapshot ? 1 : -1;
                }
                return (
                    moment(b.dateCreated).valueOf() -
                    moment(a.dateCreated).valueOf()
                );
            })
            .map((ndaTermPreference, index) => ({
                id: ndaTermPreference.id,
                name:
                    index === 0
                        ? 'Current'
                        : moment(ndaTermPreference.dateCreated).format(
                              'MM/DD/YYYY HH:mm'
                          ),
            }));
    };

    const renderSelect = () => {
        return (
            <div className="select-nda-term-preferences">
                <label>Select NDA Term Preferences Snapshot</label>
                <select
                    className="select-nda-term-preferences-option"
                    value={ndaTermPreferencesStateOptionId}
                    onChange={(event) =>
                        handleSelectChange(Number(event.target.value))
                    }>
                    {getSelectOptions().map((option) => {
                        return (
                            <option key={option.id} value={option.id}>
                                {option.name}
                            </option>
                        );
                    })}
                </select>
            </div>
        );
    };

    const renderNdaTermPreferences = () => {
        return (
            <div>
                {targetBuyer?.profile?.ndaTermPreferencesSnapshots &&
                    renderSelect()}
                <div key={ndaTermPreferencesState?.dateCreated ?? new Date()}>
                    <Form
                        initialValues={formValues}
                        enableReinitialize={true}
                        onSubmit={() => {}}>
                        <NdaTermPreferences
                            isFullScreen={true}
                            isSaving={false}
                            isReadonly={true}
                        />
                    </Form>
                </div>
            </div>
        );
    };

    return (
        <div className="buyer-nda-term-preferences-popup">
            <Rodal
                visible={true}
                onClose={() => {
                    props.close();
                }}
                width={600}
                animation={'fade'}
                showMask={true}
                centered>
                <ModalHeader className="modal-title">
                    {'Buyer NDA Term Preferences'}
                </ModalHeader>
                <ModalBody>{renderNdaTermPreferences()}</ModalBody>
            </Rodal>
        </div>
    );
};
